import dayjs from 'dayjs';
import { useTranslations } from 'next-intl';
import { cn } from '@shadcn/lib/utils';

export const CourseDuration: React.FC<{
	startDate: string;
	endDate: string;
	className?: string;
}> = ({ startDate, endDate, className }) => {
	const t = useTranslations('Course');

	const courseDurationWeeks = Math.round(dayjs(endDate).diff(dayjs(startDate), 'week', true));

	let courseDurationString = t('course-duration-weeks', { courseDurationWeeks });

	if (courseDurationWeeks < 1) {
		const _startDate = dayjs(startDate);
		const _endDate = dayjs(endDate);

		// Calculate the number of days the course touches
		let courseDurationDays = _endDate.diff(_startDate, 'day') + 1;

		// Ensure the course duration is at least 1 day
		if (courseDurationDays <= 0) {
			courseDurationDays = 1;
		}

		courseDurationString = t('course-duration-days', { courseDurationDays });
	} else if (courseDurationWeeks > 6) {
		const _startDate = dayjs(startDate);
		const _endDate = dayjs(endDate);

		// Extract start and end month and year
		const startMonth = _startDate.month(); // 0-based month index
		const startYear = _startDate.year();
		const endMonth = _endDate.month(); // 0-based month index
		const endYear = _endDate.year();

		// Calculate the number of months touched
		const courseDurationMonths = (endYear - startYear) * 12 + (endMonth - startMonth) + 1;

		courseDurationString = t('course-duration-months', { courseDurationMonths });
	}

	return (
		<p className={cn('text-gold-light text-xs uppercase', className)}>{courseDurationString}</p>
	);
};
